var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C6.47754 2.5 2 6.97915 2 12.5C2 18.0241 6.47754 22.5 12 22.5C17.5225 22.5 22 18.0241 22 12.5C22 6.97915 17.5225 2.5 12 2.5ZM12 6.93548C12.9353 6.93548 13.6935 7.69371 13.6935 8.62903C13.6935 9.56435 12.9353 10.3226 12 10.3226C11.0647 10.3226 10.3065 9.56435 10.3065 8.62903C10.3065 7.69371 11.0647 6.93548 12 6.93548ZM14.2581 17.1774C14.2581 17.4446 14.0414 17.6613 13.7742 17.6613H10.2258C9.95859 17.6613 9.74194 17.4446 9.74194 17.1774V16.2097C9.74194 15.9425 9.95859 15.7258 10.2258 15.7258H10.7097V13.1452H10.2258C9.95859 13.1452 9.74194 12.9285 9.74194 12.6613V11.6935C9.74194 11.4263 9.95859 11.2097 10.2258 11.2097H12.8065C13.0737 11.2097 13.2903 11.4263 13.2903 11.6935V15.7258H13.7742C14.0414 15.7258 14.2581 15.9425 14.2581 16.2097V17.1774Z",
    fill: "#1F67C9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-icon.35851d87.svg";
export { ForwardRef as ReactComponent };